import Reveal from "@/components/Reveal";

export default function ChiSiamo() {
    return (
        <section
            id="chi-siamo"
            data-testid="section-chi-siamo"
            className="relative bg-ink-800 py-28 lg:py-36"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <Reveal className="lg:col-span-6">
                    <div className="relative aspect-[4/5] overflow-hidden">
                        <img
                            src="/portfolio/IMG-20260514-WA0184.jpg"
                            alt="Cantiere Dogaparquet: posa di decking in essenza Garapa"
                            data-testid="chi-siamo-image"
                            className="w-full h-full object-cover grayscale-[10%] hover:grayscale-0 transition-all duration-1000"
                        />
                        <div className="absolute inset-0 ring-1 ring-inset ring-cream/10" />
                    </div>
                </Reveal>

                <Reveal className="lg:col-span-6" delay={120}>
                    <p
                        data-testid="chi-siamo-overline"
                        className="text-xs uppercase tracking-widest text-brass"
                    >
                        Chi siamo — 01
                    </p>
                    <h2
                        data-testid="chi-siamo-title"
                        className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl leading-tight"
                    >
                        Un mestiere
                        <br />
                        <span className="italic text-brass">tramandato</span>,
                        un’estetica
                        <br />
                        senza tempo.
                    </h2>
                    <div
                        data-testid="chi-siamo-paragraph"
                        className="mt-8 space-y-5 text-base lg:text-lg text-cream/70 leading-relaxed max-w-xl"
                    >
                        <p>
                            Dogaparquet nasce a Modica dall’esperienza di
                            Gianluca Occhipinti, artigiano del legno con oltre
                            vent’anni di pratica nei più diversi cantieri di
                            Sicilia. Ogni progetto è seguito personalmente,
                            dalla scelta dell’essenza fino alla finitura finale.
                        </p>
                        <p>
                            Lavoriamo solo con legni selezionati, italiani e di
                            importazione, privilegiando fornitori certificati.
                            La nostra missione è semplice: realizzare pavimenti
                            che invecchino bene, anno dopo anno.
                        </p>
                    </div>

                    <dl className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
                        <div data-testid="stat-experience">
                            <dt className="font-serif text-4xl text-brass">
                                20+
                            </dt>
                            <dd className="text-xs uppercase tracking-widest text-cream/60 mt-2">
                                Anni di esperienza
                            </dd>
                        </div>
                        <div data-testid="stat-projects">
                            <dt className="font-serif text-4xl text-brass">
                                350
                            </dt>
                            <dd className="text-xs uppercase tracking-widest text-cream/60 mt-2">
                                Progetti realizzati
                            </dd>
                        </div>
                        <div data-testid="stat-essences">
                            <dt className="font-serif text-4xl text-brass">
                                30+
                            </dt>
                            <dd className="text-xs uppercase tracking-widest text-cream/60 mt-2">
                                Essenze disponibili
                            </dd>
                        </div>
                    </dl>
                </Reveal>
            </div>
        </section>
    );
}
